import React from "react";
import { Paper } from "@mui/material";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
const AutocompletePaper = ({ ...props }) => {
  const { classes: styles } = useAutocompleteClasses();
  return /* @__PURE__ */ React.createElement(Paper, { variant: "outlined", ...props, className: styles.autocompletePaper });
};
export {
  AutocompletePaper
};
//# sourceMappingURL=AutocompletePaper.js.map
